module.exports = __webpack_public_path__ + "img/arrow-mobile.0116623f.png";